// API configuration for development and production
export const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api'  // Vercel will proxy this to your API functions
  : process.env.REACT_APP_API_URL || '/api';  // Fallback to Vercel-style API in dev

export const API_ENDPOINTS = {
  health: '/health',
  prices: '/oracle/prices',
  symbols: '/oracle/symbols',
  metrics: '/oracle/metrics',
  price: (symbol: string) => `/oracle/price/${symbol}`,
  pools: (symbol: string) => `/oracle/price/${symbol}/pools`
};

// API utility functions
export const apiUrl = (endpoint: string) => `${API_BASE_URL}${endpoint}`;

export const fetchWithRetry = async (
  url: string, 
  options: RequestInit = {}, 
  retries = 3
): Promise<Response> => {
  const fullUrl = url.startsWith('http') ? url : apiUrl(url);
  
  for (let i = 0; i < retries; i++) {
    try {
      const response = await fetch(fullUrl, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
      });
      
      if (response.ok) {
        return response;
      }
      
      // If it's the last retry or a client error, throw
      if (i === retries - 1 || response.status < 500) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      console.warn(`API request attempt ${i + 1} failed:`, error);
      
      // If it's the last retry, throw the error
      if (i === retries - 1) {
        throw error;
      }
      
      // Wait before retrying (exponential backoff)
      await new Promise(resolve => setTimeout(resolve, Math.pow(2, i) * 1000));
    }
  }
  
  throw new Error('All retry attempts failed');
};
